export const checkHistoryDiff = (index, batchHistorical, historyItem) => {
  const excludeFieldDiff = [
    "id",
    "createdTime",
    "createdBy",
    "createdDate",
    "stageId",
    "blitzStep",
    "createdDateTime",
    "updatedDateTime"
  ];
  const diff = {};
  if (index) {
    const previousItem = batchHistorical[index - 1];
    const previousToCompare =
      previousItem.stageId === 9 ? batchHistorical[index - 2] : previousItem;
    for (const key in historyItem) {
      if (
        !excludeFieldDiff.includes(key) &&
        historyItem[key] !== previousToCompare[key]
      ) {
        diff[key] = historyItem[key];
      }
    }
  }
  return diff;
};
